function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import request from '@/utils/request';
import { normalizeTheme, normalizeThemeInfo, normalizeThemeList, normalizeThemeCategoryTree, normalizeUsingTheme, toThemeListParams } from '@/utils/themeAdapter';
function normalizeSaveResult() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = value && _typeof(value) === 'object' ? value : {
    id: value
  };
  return _objectSpread(_objectSpread({}, data), {}, {
    data: data,
    msg: '保存成功',
    message: '保存成功'
  });
}
export function getThemeList(params) {
  return request({
    url: '/admin/theme/list',
    method: 'get',
    params: toThemeListParams(params)
  }).then(normalizeThemeList);
}
export function getMicroPageList(params) {
  return getThemeList(_objectSpread(_objectSpread({}, params), {}, {
    pageType: 'micro'
  }));
}
export function themeInfo(id, type) {
  return request({
    url: '/admin/theme/info',
    method: 'get',
    params: {
      id: id,
      type: type
    }
  }).then(function (data) {
    var value = normalizeThemeInfo(data || {}, type);
    return _objectSpread(_objectSpread({}, value), {}, {
      data: value
    });
  });
}
export function themeSave(id, data) {
  return request({
    url: '/admin/theme/saveTheme',
    method: 'post',
    params: {
      id: id
    },
    data: data
  }).then(normalizeSaveResult);
}
export function saveThemeTitle(id, data) {
  if (Number(id || 0) === 0 && data && data.page_type === 'micro') {
    var createData = {
      type: 'home',
      value: '',
      title: data.title,
      tid: data.tid,
      page_type: 'micro'
    };
    return themeSave(0, createData).then(function (createResult) {
      var themeId = createResult.data.id;
      return request({
        url: '/admin/theme/saveTitleInfo',
        method: 'post',
        params: {
          id: themeId
        },
        data: {
          title: data.title,
          info: data.info,
          page_type: 'micro'
        }
      }).then(function () {
        return createResult;
      });
    });
  }
  return request({
    url: '/admin/theme/saveTitleInfo',
    method: 'post',
    params: {
      id: id,
      tid: data && data.tid
    },
    data: data
  }).then(normalizeSaveResult);
}
export function saveThemeTitleInfo(data) {
  return request({
    url: '/admin/theme/saveTitleInfo',
    method: 'post',
    data: data
  });
}
export function saveThemeImage(id, data) {
  return request({
    url: '/admin/theme/saveThemeImage',
    method: 'post',
    params: {
      id: id
    },
    data: data
  }).then(normalizeSaveResult);
}
export function fileUpload(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    model: 'theme',
    pid: 0
  };
  return request({
    url: '/admin/upload/image',
    method: 'post',
    params: params,
    data: data
  }).then(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread({
      status: 200,
      data: _objectSpread({
        src: value.sattDir || value.att_dir || value.url || value.src || value.fileUrl || ''
      }, value)
    }, value);
  });
}
export function importTheme(data) {
  return request({
    url: '/admin/theme/import',
    method: 'post',
    data: data
  });
}
export function exportTheme(id) {
  return request({
    url: '/admin/theme/export',
    method: 'get',
    params: {
      id: id
    }
  });
}
export function getExportRecord(id) {
  return request({
    url: '/admin/theme/export/url',
    method: 'get',
    params: {
      record_id: id
    }
  });
}
export function useTheme(id) {
  return request({
    url: '/admin/theme/use/' + id,
    method: 'get'
  });
}
export function getThemeUsing() {
  return request({
    url: '/admin/theme/using',
    method: 'get'
  }).then(function (data) {
    var value = normalizeUsingTheme(data);
    return _objectSpread(_objectSpread({}, value), {}, {
      data: value
    });
  });
}
export function restoreTheme(id) {
  return request({
    url: '/admin/theme/restore/' + id,
    method: 'get'
  });
}
export function useThemeData(id, params) {
  return request({
    url: '/admin/theme/use_data/' + id,
    method: 'get',
    params: params
  });
}
export function deleteTheme(id) {
  return request({
    url: '/admin/theme/delete',
    method: 'get',
    params: {
      id: id
    }
  });
}
export function getThemeVersion(params) {
  return request({
    url: '/admin/theme/version',
    method: 'get',
    params: params
  });
}
export function themeProductCategory() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    status: -1
  };
  return request({
    url: '/admin/theme/product/category',
    method: 'get',
    params: params
  }).then(function (data) {
    var list = normalizeThemeCategoryTree(data);
    return {
      data: list,
      list: list
    };
  });
}
export function categoryList(params) {
  return request({
    url: '/admin/theme/product/category',
    method: 'get',
    params: _objectSpread({
      status: -1
    }, params)
  }).then(function (data) {
    var list = normalizeThemeCategoryTree(data);
    return {
      data: list,
      list: list
    };
  }).catch(function () {
    return {
      data: [],
      list: []
    };
  });
}
export function getCategory() {
  return request({
    url: '/admin/category/list/tree',
    method: 'get'
  }).catch(function () {
    return [];
  });
}
function toThemeProductParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cateId = Array.isArray(params.cate_id || params.cate_ids) ? (params.cate_id || params.cate_ids).join(',') : params.cate_id || params.cate_ids;
  return {
    page: params.page,
    limit: params.limit,
    cate_id: cateId,
    store_name: params.store_name,
    priceOrder: params.priceOrder,
    salesOrder: params.salesOrder
  };
}
function normalizeThemeProductPage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var list = Array.isArray(data) ? data : data.list || [];
  var pageData = Array.isArray(data) ? {} : data;
  return {
    data: list,
    list: list,
    count: pageData.count || pageData.total || list.length
  };
}
export function getProProduct(params) {
  return request({
    url: '/admin/theme/product/list',
    method: 'get',
    params: toThemeProductParams(params)
  }).then(normalizeThemeProductPage).catch(function () {
    return {
      data: [],
      list: [],
      count: 0
    };
  });
}
export function getProductList(params) {
  return getProProduct(params).then(function (res) {
    return _objectSpread(_objectSpread({}, res), {}, {
      data: {
        list: res.list,
        count: res.count
      }
    });
  });
}
export function getThemeProduct(params) {
  return getProProduct(params);
}
function toThemeArticleParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    page: params.page,
    limit: params.limit,
    cid: params.cid || params.pid || ''
  };
}
function normalizeThemeArticle() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imageInput = Array.isArray(item.image_input) ? item.image_input : Array.isArray(item.imageInput) ? item.imageInput : item.image ? [item.image] : [];
  return _objectSpread(_objectSpread({}, item), {}, {
    cid: item.cid || '',
    image_input: imageInput,
    image: item.image || imageInput[0] || '',
    title: item.title || '',
    visit: item.visit || '',
    add_time: item.add_time || item.addTime || ''
  });
}
function normalizeThemeArticlePage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pageData = Array.isArray(data) ? {
    list: data,
    count: data.length
  } : data || {};
  var list = Array.isArray(pageData.list) ? pageData.list.map(normalizeThemeArticle) : [];
  return {
    data: {
      list: list,
      count: pageData.count || pageData.total || list.length
    },
    list: list,
    count: pageData.count || pageData.total || list.length
  };
}
export function themeArticleCategory() {
  return request({
    url: '/admin/theme/article/category',
    method: 'get'
  }).then(function (data) {
    var list = normalizeThemeCategoryTree(data);
    return {
      data: list,
      list: list
    };
  });
}
export function getArticleList(params) {
  return request({
    url: '/admin/theme/article/list',
    method: 'get',
    params: toThemeArticleParams(params)
  }).then(normalizeThemeArticlePage).catch(function () {
    return {
      data: {
        list: [],
        count: 0
      },
      list: [],
      count: 0
    };
  });
}
export function getCouponList(params) {
  return request({
    url: '/admin/marketing/coupon/list',
    method: 'get',
    params: params
  }).then(function (data) {
    return data.list || data;
  }).catch(function () {
    return [];
  });
}
export function getRoutineCode() {
  return Promise.resolve({
    image: ''
  });
}
export function diyUpdateName() {
  return Promise.resolve({});
}
export function setDefault() {
  return Promise.resolve({});
}
export function recovery() {
  return Promise.resolve({});
}
export function getMember() {
  return Promise.resolve({});
}
export function memberSave() {
  return Promise.resolve({});
}
export function getWordsAll() {
  return Promise.resolve([]);
}
export function getDiyField() {
  return request({
    url: '/admin/theme/text/field',
    method: 'get'
  }).then(function (data) {
    return {
      data: data || {}
    };
  });
}
export function newcomerList() {
  return Promise.resolve([]);
}
export function diyProList() {
  return Promise.resolve({
    list: [],
    count: 0
  });
}
export function diyDel() {
  return Promise.resolve({});
}
export function setStatus() {
  return Promise.resolve({});
}
export function exportDiyDataApi() {
  return Promise.resolve({});
}
export function colorChange() {
  return Promise.resolve({});
}
export function getColorChange() {
  return Promise.resolve({});
}
export function getUrl() {
  return Promise.resolve({
    url: []
  });
}
export function diyGetInfo() {
  return Promise.resolve({});
}
export function diySave() {
  return Promise.resolve({});
}
export { normalizeTheme, normalizeThemeInfo, normalizeThemeList, normalizeUsingTheme };